import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import TrainerDashboard from "@/pages/TrainerDashboard";
import ClientDashboard from "@/pages/ClientDashboard";
import LandingPage from "@/pages/LandingPage";

function RoleGate({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-white/50 label-caps">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/trainer" : "/app"} replace />;
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/trainer" : "/app"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/presentazione" element={<LandingPage />} />
            <Route path="/trainer/*" element={<RoleGate role="admin"><TrainerDashboard /></RoleGate>} />
            <Route path="/app/*" element={<RoleGate role="client"><ClientDashboard /></RoleGate>} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </div>
    </AuthProvider>
  );
}
